import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "previews"]
  static values = { max: { type: Number, default: 4 } }

  open(event) {
    if (event.target.closest("button")) return
    this.inputTarget.click()
  }

  stop(event) {
    event.stopPropagation()
  }

  pick() {
    this.trim()
    this.sync()
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("is-dragover")
  }

  dragleave() {
    this.element.classList.remove("is-dragover")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("is-dragover")
    const incoming = Array.from(event.dataTransfer.files).filter((file) => file.type.startsWith("image/"))
    this.merge(incoming)
  }

  remove(event) {
    const index = Number(event.currentTarget.dataset.index)
    const dt = new DataTransfer()
    Array.from(this.inputTarget.files).forEach((file, i) => {
      if (i !== index) dt.items.add(file)
    })
    this.inputTarget.files = dt.files
    this.sync()
  }

  merge(files) {
    const dt = new DataTransfer()
    const current = Array.from(this.inputTarget.files)
    ;[...current, ...files].slice(0, this.maxValue).forEach((file) => dt.items.add(file))
    this.inputTarget.files = dt.files
    this.sync()
  }

  trim() {
    const files = Array.from(this.inputTarget.files).slice(0, this.maxValue)
    const dt = new DataTransfer()
    files.forEach((file) => dt.items.add(file))
    this.inputTarget.files = dt.files
  }

  sync() {
    this.previewsTarget.replaceChildren()
    Array.from(this.inputTarget.files).forEach((file, index) => {
      const wrap = document.createElement("div")
      wrap.className = "brand-import-thumb"
      const img = document.createElement("img")
      img.src = URL.createObjectURL(file)
      img.alt = file.name
      const btn = document.createElement("button")
      btn.type = "button"
      btn.className = "brand-import-thumb-remove"
      btn.dataset.index = String(index)
      btn.setAttribute("aria-label", "Remover")
      btn.textContent = "×"
      btn.addEventListener("click", (event) => this.remove(event))
      wrap.append(img, btn)
      this.previewsTarget.append(wrap)
    })
  }
}
